import type { SVGProps } from "react";

/** A compact music-note mark, styled by the surrounding social link. */
export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true" focusable="false" {...props}><path d="M14 3h3c0 2.1 1.6 3.7 4 4v3c-1.5 0-2.9-.5-4-1.3V16a6 6 0 1 1-6-6v3a3 3 0 1 0 3 3V3Z"/></svg>;
}
